import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React, { memo, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import toastService from "Root/profile/toastService";
import { apiGetQuizData, apiPostQuizAnswer, apiQuizFinish, apiAttribution } from "Root/api/apiQuiz";
import { useTracking } from "react-tracking";
import QuizTrack from "Root/quiz/data/trackingEnums";
import ButtonBar from "../buttonBar/buttonBar";
import EmailSignUp from "../emailSignUp/emailSignUp";
import ProgressBar from "../progressBar";
import QuizContent from "../quizContent/quizContent";
import QuizHeader from "../quizHeader";
import { getHideBottomBar, getIsInterstitial } from "Root/quiz/helpers/questionHelper";
import BlackFridayBanner from "Root/profile/components/common/BlackFridayBanner";
import { useLocation } from "react-router";
import styles from "./styles.module.css";
import * as api from "Root/api/apiCommon";
import posthog from "posthog-js";
import GainfulLoading from "Components/GainfulLoading";
const QuizPage = () => {
    const { quizName } = useParams();
    const [currentQuestion, setCurrentQuestion] = useState({});
    const [quizData, setQuizData] = useState([]);
    const [questionNumber, setQuestionNumber] = useState(1); // TODO: load this in from backend
    const [previousQuestionNumber, setPreviousQuestionNumber] = useState(1); // TODO: load this in from backend
    const [quizAnswers, setQuizAnswers] = useState({});
    const [value, setValue] = useState([]);
    const [freeFormValue, setFreeFormValue] = useState({});
    const [backLinks, setBackLinks] = useState({}); // TODO: load this in from backend
    const [endOfQuiz, setEndOfQuiz] = useState(false);
    // const [isRedirect, setIsRedirect] = useState(false);
    const [headerIn, setHeaderIn] = useState(false);
    const [progBarIn, setProgBarIn] = useState(false);
    const [showGuestCheckout, setShowGuestCheckout] = useState(false);
    const [showQuestionContent, setShowQuestionContent] = useState(false);
    const [showBottom, setShowBottom] = useState(false);
    const [scrolledToBottom, setScrolledToBottom] = useState(false);
    // const [locationKeys, setLocationKeys] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);
    const [isAddonQuiz, setIsAddonQuiz] = useState(false);
    // const [is'rdInterstital, setIsAddonQuiz] = useState(false);
    const [bannerText, setBannerText] = useState("");
    // metrics change for height and weight
    const [metrics, setMetrics] = useState(false);
    const [bannerData, setBannerData] = useState({ copy: "", code: "" });
    const [postSignupUrl, setPostSignupUrl] = useState("");
    const { pathname } = useLocation();
    const isTargetQuiz = pathname.indexOf("target") !== -1;
    const isHyroxQuiz = pathname.indexOf("hyrox") !== -1;
    const history = useHistory();
    const { trackEvent } = useTracking();
    const trackStartQuiz = () => {
        trackEvent({
            funComponent: "quiz",
            event: `${QuizTrack.start_quiz}`,
        });
    };
    const trackFinishQuiz = () => {
        trackEvent({
            funComponent: "quiz",
            event: `${QuizTrack.finish_quiz}`,
        });
    };
    const validateHeightAndWeight = (values) => {
        if (!value) {
            return false;
        }
        if (Number(values[0]) < 50 || Number(values[0]) > 600) {
            toastService.errorMessage(metrics ? "Weight should be between 23 and 272 kgs" : "Weight should be between 50 and 600 lbs");
            return false;
        }
        if (Number.isNaN(Number(values[1])) || Number(values[1]) > 95 || Number(values[1]) < 24) {
            toastService.errorMessage(metrics ? "Height should be between 61cm and 2 m 41cm" : "Height should be between 2ft and 7 ft 11in");
            return false;
        }
        return true;
    };
    const goToQstNameRoute = (question) => {
        if (question) {
            history.push(`/quiz-new/${quizName}/${question.questionName}${window.location.search}/`);
        }
        else if (currentQuestion) {
            history.push(`/quiz-new/${quizName}/${currentQuestion.questionName}${window.location.search}/`);
        }
    };
    const awaitPushAnswers = (question, answer) => {
        const quizAnswerCopy = { ...quizAnswers };
        quizAnswerCopy[question] = answer;
        const newData = quizData.map((elem) => {
            if (elem.questionName === question) {
                return { ...elem, userAnswer: answer };
            }
            return elem;
        });
        setQuizData(newData);
        setQuizAnswers(quizAnswerCopy);
    };
    const validateAnswer = (answer) => {
        if (currentQuestion?.questionName === "RDQuestion") {
            return true; // allows to store to answers empty string
        }
        return answer !== "";
    };
    const pushAnswers = () => {
        let str = "";
        // hardcode questiontype
        if (currentQuestion?.questionName === "heightAndWeight") {
            if (!validateHeightAndWeight(value)) {
                return undefined;
            }
        }
        if (typeof value === "object" && value.length > 1) {
            str = value.reduce((prev, next) => `${prev},${next}`);
        }
        else {
            str = value.toString();
        }
        if (validateAnswer(str)) {
            currentQuestion && awaitPushAnswers(currentQuestion?.questionName, str);
            return true;
        }
        toastService.errorMessage("Please select an answer");
        return false;
    };
    const buildAnswer = (question, answers) => {
        const keys = Object.keys(answers);
        const index = keys.findIndex((val) => val === question.questionName);
        const key = keys[index];
        let free_form_val = null;
        if (question.questionType === "text_area") {
            free_form_val = answers[key];
        }
        else {
            free_form_val = freeFormValue[key];
        }
        const answerObject = index !== -1
            ? {
                quizName,
                answer: answers[key],
                question: key,
                free_form: free_form_val,
                option: currentQuestion.options?.find((item) => item.free_form)?.value,
            }
            : null;
        return answerObject;
    };
    useEffect(() => {
        const answer = buildAnswer(currentQuestion, quizAnswers);
        if (answer) {
            apiPostQuizAnswer(answer);
            posthog.capture("quiz_question_answered", answer);
        }
    }, [quizAnswers]);
    useEffect(() => {
        if (currentQuestion && currentQuestion.userAnswer) {
            if (currentQuestion.questionType === "text_area") {
                setValue([currentQuestion.userAnswer]);
            }
            else if (!isHyroxQuiz)
                setValue(currentQuestion.userAnswer.split(",").filter((elem) => elem !== ","));
            goToQstNameRoute(currentQuestion);
            setFreeFormValue({
                ...freeFormValue,
                [currentQuestion.questionName]: freeFormValue[currentQuestion.questionName] || currentQuestion.free_form_answer,
            });
        }
        else {
            setValue([]);
        }
        window.scrollTo(0, 0);
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
            setScrolledToBottom(false);
        }
        else {
            setScrolledToBottom(true);
        }
        if (quizData.length > 0 && questionNumber > quizData.length) {
            setEndOfQuiz(true);
        }
    }, [currentQuestion]);
    const needToPrune = (pruneObj) => {
        if ("AND" in pruneObj) {
            const elems = pruneObj.AND;
            if (elems?.length === 1) {
                return needToPrune(elems[0]);
            }
            return elems && needToPrune(elems[0]) && needToPrune({ AND: elems.slice(1) });
        }
        if ("OR" in pruneObj) {
            const elems = pruneObj.OR;
            if (elems?.length === 1) {
                return elems && needToPrune(elems[0]);
            }
            return (elems && needToPrune(elems[0])) || (elems && needToPrune({ OR: elems.slice(1) }));
        }
        // base case!
        const { question, answer, lookupType } = pruneObj;
        if (question in quizAnswers) {
            const userAnswer = quizAnswers[question];
            if (lookupType === "equals") {
                return answer === userAnswer;
            }
            if (lookupType === "does_not_equal") {
                return answer !== userAnswer;
            }
            const userAnswerArray = userAnswer.split(",");
            if (lookupType === "contains") {
                return userAnswerArray.indexOf(answer) >= 0;
            }
            if (lookupType === "does_not_contain") {
                return userAnswerArray.indexOf(answer) < 0;
            }
        }
        return false;
    };
    const resetAnimations = () => {
        setShowQuestionContent(false);
    };
    const loadAnimations = (initial = false) => {
        if (initial) {
            setTimeout(() => {
                setHeaderIn(true);
            }, 100);
            setTimeout(() => {
                setProgBarIn(true);
            }, 600);
            setTimeout(() => {
                setShowQuestionContent(true);
                setShowBottom(true);
            }, 700);
        }
        else {
            setTimeout(() => {
                setShowQuestionContent(true);
            }, 100);
        }
    };
    const backHome = () => {
        history.push("/");
        window.location.reload();
    };
    const goBack = () => {
        resetAnimations();
        if (endOfQuiz) {
            setEndOfQuiz(false);
            setTimeout(() => {
                setShowBottom(false);
            }, 100);
            setTimeout(() => {
                setShowBottom(true);
            }, 500);
        }
        else if (questionNumber in backLinks) {
            setQuestionNumber(backLinks[questionNumber]);
            setPreviousQuestionNumber(backLinks[questionNumber]);
        }
        else {
            const newQuestionNum = Math.max(1, questionNumber - 1);
            setQuestionNumber(newQuestionNum);
            setPreviousQuestionNumber(newQuestionNum);
        }
        loadAnimations();
    };
    const goNext = async () => {
        const isInterstitial = getIsInterstitial(currentQuestion?.questionType);
        const valid = isInterstitial ? true : pushAnswers();
        if (valid) {
            resetAnimations();
            if (questionNumber + 1 <= quizData.length) {
                if (questionNumber === 1) {
                    trackStartQuiz();
                }
                setQuestionNumber(questionNumber + 1);
                setValue([]);
                // track quiz question and answer
            }
            else {
                const urlParams = new URLSearchParams(window.location.search);
                sessionStorage.removeItem("is_future");
                sessionStorage.removeItem("future_creds");
                trackFinishQuiz();
                const redirectData = await apiQuizFinish({
                    quizAnswers,
                    freeFormAnswers: freeFormValue,
                    isAddonQuiz,
                    quizName,
                    product: urlParams.get("product"),
                });
                if (redirectData.postSignupUrl) {
                    setPostSignupUrl(redirectData.postSignupUrl);
                }
                if (redirectData.showGuestCheckout) {
                    setShowGuestCheckout(redirectData.showGuestCheckout);
                }
                if (redirectData.redirect) {
                    history.push(redirectData.redirect);
                    window.location.reload();
                }
                else {
                    setEndOfQuiz(true);
                }
            }
            loadAnimations();
        }
    };
    useEffect(() => {
        const thisQuestion = quizData[Number(questionNumber) - 1];
        if (thisQuestion?.pruneIf && Object.keys(thisQuestion?.pruneIf).length !== 0) {
            if (needToPrune(thisQuestion.pruneIf)) {
                setQuestionNumber(questionNumber + 1);
                return;
            }
        }
        // Below is to handle the back link fxnality
        if (previousQuestionNumber < questionNumber) {
            // only do this when going forward
            // on init
            const prevQNumCopy = previousQuestionNumber;
            const backLinkCopy = backLinks;
            backLinkCopy[questionNumber] = prevQNumCopy;
            setBackLinks(backLinkCopy);
            if (!thisQuestion?.isInterstitial) {
                setPreviousQuestionNumber(questionNumber);
            }
        }
        if (thisQuestion) {
            goToQstNameRoute(thisQuestion);
        }
        setCurrentQuestion(thisQuestion);
    }, [questionNumber]);
    const calculateProgress = () => {
        if (endOfQuiz) {
            return 100;
        }
        return Math.max(2, ((Number(questionNumber) - 1) * 100) / quizData.length);
    };
    // eslint-disable-next-line func-names
    window.onpopstate = function (e) {
        if (questionNumber > 1) {
            e.preventDefault();
            goBack();
        }
        else {
            window.history.back();
        }
    };
    const getBannerCopy = async () => {
        const promo_banner = await api.getPromotionalBanner();
        const data = { copy: promo_banner.copy, code: promo_banner.code };
        setBannerData(data);
    };
    useEffect(() => {
        apiGetQuizData(quizName || "test").then((data) => {
            setIsAddonQuiz(quizName === "addon-quiz");
            setQuizData(data.questions);
            setBannerText(data.banner_text);
            const requestQuestNumber = Number(data.current_question_number);
            setQuestionNumber(requestQuestNumber);
            setCurrentQuestion(data.questions[requestQuestNumber - 1]);
            loadAnimations(true);
            goToQstNameRoute(data.questions[requestQuestNumber - 1]);
            setBackLinks(data.back_links);
            if (!quizName.includes("hyrox")) {
                setQuizAnswers(data.quizAnswers);
            }
            else {
                setQuizAnswers({});
            }
            setDataLoading(false);
        });
        apiAttribution({ react: true });
        window.addEventListener("scroll", () => {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
                setScrolledToBottom(false);
            }
            else {
                setScrolledToBottom(true);
            }
        });
        getBannerCopy();
    }, []);
    const noAnswerSelected = currentQuestion?.questionName === "RDQuestion"
        ? false // next btn is enabled anyway for this question
        : !getIsInterstitial(currentQuestion?.questionType) && value.length === 0;
    const autoNext = ["product_checkbox", "radio", "checkbox"].includes(currentQuestion?.questionType) &&
        isHyroxQuiz &&
        currentQuestion.maxOptions === 1;
    return (_jsxs(_Fragment, { children: [bannerText !== "" && (_jsx("div", { id: "bannerText", className: styles.bannerText, style: { background: "#ecff7a", textAlign: "center", padding: "5px" }, children: _jsx("div", { style: { maxWidth: "80%", margin: "auto" }, children: _jsx("span", { children: bannerText.toUpperCase() }) }) })), _jsx("div", { style: { background: "white", minHeight: "100%", width: "100vw" }, children: _jsx("div", { style: { background: "#f4f0e8" }, children: dataLoading ? (
                    // <QuizLoading text="Getting your quiz ready..." />
                    _jsx(GainfulLoading, {})) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.quiz_header_wrapper, children: [!bannerText && !isTargetQuiz && !isHyroxQuiz && (_jsx(BlackFridayBanner, { className: "banner_1m_order_quiz", data: bannerData })), _jsx(QuizHeader, { goBack: goBack, onClose: backHome, showHeader: headerIn, isFirstQuestion: previousQuestionNumber === 1, isFuture: !!window.localStorage.getItem("h") }), _jsx(ProgressBar, { value: calculateProgress(), showBar: progBarIn, bannerText: bannerText, isTargetQuiz: isTargetQuiz })] }), endOfQuiz ? (_jsx(EmailSignUp, { quizAnswers: quizAnswers, postSignupUrl: postSignupUrl, showGuestCheckout: showGuestCheckout })) : (currentQuestion && (_jsxs(_Fragment, { children: [_jsx(QuizContent, { quizAnswers: quizAnswers, show: showQuestionContent, question: currentQuestion, value: value, setValue: setValue, setFreeFormValue: setFreeFormValue, freeFormValue: freeFormValue[currentQuestion.questionName], questionName: currentQuestion.questionName, goNext: goNext, quizContentNoButtonBar: getHideBottomBar(currentQuestion.questionType), metrics: metrics, setMetrics: setMetrics, autoNext: autoNext }, "quizContent"), !autoNext && (_jsx(ButtonBar, { label: "Next", isHyrox: isHyroxQuiz, gonext: goNext, disabled: noAnswerSelected, showBottom: getHideBottomBar(currentQuestion.questionType) ? false : showBottom, scrolledToBottom: scrolledToBottom }, "buttonbar"))] })))] })) }) })] }));
};
export default memo(QuizPage);
